import React, { useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router';
import { useSelector } from 'react-redux';
import { AppStateType } from '../../../redux/reducers';
import { AccessibilityUnit } from '../../../models/AccessibilityUnits';
import { A11yStandardType } from '../../../models/utils';
import { Property } from '../../../models/Property';
import { RenderFacilitiesItem } from './RenderFacilitiesItem';
import { scrollToElement } from '../../../utils/functions';
import { CurrentUnit } from '../../../components/contexts/UnitsContext';

export type ChosenUnit = { facilitiesIndex: number | null, unityIndex: number | null, unityId: string | null }
type RenderFacilitiesType = {
    property: Property,
    setCurrentUnit: React.Dispatch<CurrentUnit>,
    setExistingUnit: React.Dispatch<AccessibilityUnit | null>,
    setChosenUnit: React.Dispatch<ChosenUnit>,
    a11yStandard: A11yStandardType
}

export const RenderFacilities = ({ property, setChosenUnit, setCurrentUnit, setExistingUnit, a11yStandard }: RenderFacilitiesType) => {
    const { url } = useRouteMatch();
    const units: AccessibilityUnit[] = useSelector((state: AppStateType) => state.unitsReducer.units);
    const facilities: string[] = useSelector((state: AppStateType) => state.facilitiesReducer.facilities);
    const [expanded, setExpanded] = useState<string | false>("accordion-0");

    useEffect(() => {
        setExistingUnit(null)
        setChosenUnit({ facilitiesIndex: null, unityIndex: null, unityId: null })
    }, [])

    const handleChangeAccordion = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };
    const handleNewUnitClick = (unitType: string, name: string) => {
        scrollToElement("app-header")
        const currentUnit = {
            name: name,
            type: unitType,
            property: property.id
        }
        setExistingUnit(null)
        setCurrentUnit(currentUnit)
        setChosenUnit({facilitiesIndex: null, unityIndex: null, unityId: null})
    }
    if (!a11yStandard || !facilities) {
        return null;
    }
    return (
        <div>
            {facilities?.map((item, index) => {
                if (url.includes('classify') && units.filter((unit) => unit.type === item).length < 1) {
                    return null
                }
                let currentUnit = a11yStandard.values.find((unit) => unit.key === item);

                if (!currentUnit) {
                    return null;
                }

                return (
                    <RenderFacilitiesItem
                        key={index}
                        index={index}
                        unitKey={currentUnit.key}
                        handleNewUnitClick={handleNewUnitClick}
                        item={currentUnit.title}
                        expanded={expanded}
                        handleChangeAccordion={handleChangeAccordion}
                    />
                )
            })}
        </div>
    )
}
